<section *ngIf="showcases?.length">
  <div class="row pt-5 px-2 pb-4 pb-sm-9">
    <div class="header-container col-sm">
      <ng-container *ngIf="showcaseType !== showcasesTypes.CUSTOM; else customShowcaseTitle">
        <span class="icon-topics"></span>
        <h3 class="title" data-automation-id="multiple-showcases-view-title">
          <ng-container *ngIf="entity.entityType === CONCEPT">
            {{ 'topicsTitleRelatedTopics' | translate }}
          </ng-container>
          <ng-container *ngIf="entity.entityType !== CONCEPT">
            {{ 'topics' | translate }}
          </ng-container>
        </h3>
      </ng-container>
      <ng-template #customShowcaseTitle>
        <span class="custom-showcase-icon fas fa-book-reader mr-3"></span>
        <div class="d-inline-flex flex-column">
          <h3 class="title" data-automation-id="multiple-showcases-view-title" translate>customShowcaseLibraryLists</h3>
        </div>
      </ng-template>
    </div>
    <app-see-all-button class="col-auto" *ngIf="isSeeAllButtonVisible" seeAllType="see-all-multiple-showcases"
      [url]="showcaseType === showcasesTypes.CUSTOM ? ['/library-list', 'showcase', identifier] : ['/search', 'card']"
      [queryParams]="{
        id: entity.id,
        entityType: entity.entityType,
        showcase: showcaseType,
        identifier: showcaseType,
        showcaseId: showcaseId || null
      }">
      <span data-automation-id="multiple-showcases-see-all-text">
        <ng-container *ngIf="showcaseType !== showcasesTypes.CUSTOM; else customShowcaseSeeAll">
          <ng-container *ngIf="entity.entityType === CONCEPT">
            {{ 'seeAllTitleRelatedTopics' | translate:{ count: totalCount } }}
          </ng-container>
          <ng-container *ngIf="entity.entityType !== CONCEPT">
            {{ 'seeAllTopicsWithCount' | translate:{ count: totalCount } }}
          </ng-container>
        </ng-container>
        <ng-template #customShowcaseSeeAll>
          {{ 'seeAllShowcaseLibrarianLists' | translate:{ count: totalCount } }}
        </ng-template>
      </span>
    </app-see-all-button>
  </div>
  <ul class="row content px-4 px-sm-19 px-md-15 list-unstyled mb-0">
    <li *ngFor="let showcase of showcases; index as i;"
         class="col-md-6 d-flex flex-column justify-content-between multiple-showcase px-0 px-md-4 mb-6 mb-sm-9 mb-md-15"
         data-automation-id="multiple-showcase">
      <app-multiple-showcase [showcase]="showcase" [index]="i" [entity]="entity" [showcaseType]="showcaseType"></app-multiple-showcase>
    </li>
  </ul>
</section>
